import {ConfirmationService, MessageService} from "primeng/api";
import {Table, TableLazyLoadEvent} from "primeng/table";
import {NavigationEnd, Router} from "@angular/router";
import {Component, Injectable, Injector} from "@angular/core";
import {FilterMetadata} from "primeng/api/filtermetadata";
import {Equal, FindManyOptions, FindOperator, ILike, IsNull, LessThan, MoreThan, Not, Or, Repository,} from "typeorm";
import {FindOptionsWhere} from "typeorm/browser/find-options/FindOptionsWhere";
import {FindOptionsOrder} from "typeorm/browser/find-options/FindOptionsOrder";
import {IRepository} from "../../services/persist/IRepository";

export abstract class AbstractListOrmComponent<T> {
    total = 0
    loading = false;
    entidades: T[] = []
    router: Router
    abstract agenciavel: boolean
    messageService: MessageService
    confirmationService: ConfirmationService
    event?: TableLazyLoadEvent
    protected constructor(injector: Injector, protected repo: IRepository<T>) {
        this.messageService  = injector.get(MessageService)
        this.router = injector.get(Router)
        this.confirmationService = injector.get(ConfirmationService)
        this.router.events.subscribe(event =>{
        if (event instanceof NavigationEnd &&
          event.url == window.location.pathname &&
          this.event
        ) {
          this.load(this.event).then()
        }
      })
    }
    relations  : string[] = []
  abstract select : string[]

  onIonInfinite(ev: any) {
      if(this.event != undefined){
        const rows = this.event.rows || 10
        const first = this.event.first  || 0
        this.event.first = first + rows
        this.load(this.event).then()
      }
  }

  clear(table: Table) {
        table.clear();
    }
  async load(event: TableLazyLoadEvent){
        this.event = event
        // const json = JSON.stringify(event)
        // console.log(json)
        // console.log(encodeURIComponent(json))
        // event = JSON.parse(json)
        const find: FindManyOptions = {
          relations: this.relations,
          select: this.select,
          take: event.rows|| 10,
          skip:  event.first||0,
          where: this.createPredicates(event),
          order: this.orderBy(event),
        }

        const [entidades, total] = await this.repo.findAndCount(find)
        this.entidades = entidades
        this.total = total
        return this.entidades

  }

  createPredicates( event: TableLazyLoadEvent) :FindOptionsWhere<T> {
    let where: FindOptionsWhere<any> = this.agenciavel ? {agencia_sigla: localStorage.getItem("agencia")} : {}
    where['excluido'] = Or(Equal(false), IsNull())
    const filters = event.filters
    if(filters != undefined) {
      const filtros = Object.getOwnPropertyNames(filters)
      filtros.forEach(nome => {
        const valor = (filters[nome] as FilterMetadata[])
        valor.forEach(filtro => {
          if (filtro.value != null) {
            const resp = this.createNestedObject(nome, this.createPredicate(filtro))
            where = {...where,  ...resp}
            // where[nome] = this.createPredicate(filtro)
          }
        })
      })
    }
    return where

  }
  createPredicate( filter: FilterMetadata): FindOperator<any> {
    const value = filter.value
    switch (filter.matchMode) {
      case 'startsWith': return ILike(value + '%')
      case 'endsWith': return ILike('%'+value)
      case 'contains': return ILike('%'+value+'%')
      case 'notContains': return Not(ILike('%'+value+'%'))

      case 'containsMember': return ILike('%'+value+'%')
      // case 'in': return f => {
      //     const valor = this.resolvePath(f, campo)
      //     return valorFiltro.includes(valor)
      // }
      case 'equals': return Equal(value)
      case 'isnull': return IsNull()
      case 'isnotnull': return Not(IsNull())
      case 'notEquals': return Not(Equal(value))
      case 'dateIs': return Equal(value)
      case 'dateBefore': return LessThan(value)
      case 'dateAfter': return MoreThan(value)
      case 'dateIsNot': return Not(Equal(value))
      default:
        throw new Error('operador não encontrado')
    }
  }


  createNestedObject(keys: string, value: any){
    const tempObject = {};
    let container: any = tempObject;
    // const order = sentido== 1? 'ASC': 'DESC'
    keys.split('.').map((k, i, values) => {
      container = (container[k] = (i == values.length - 1 ? value : {}))
    });
    return tempObject
  }


  orderBy(event: TableLazyLoadEvent) : FindOptionsOrder<any>{
    let obj: any = {}
    if (event.sortField !== undefined && event.sortField != null) {
        obj = this.createNestedObject(event.sortField as string, event.sortOrder == 1 ? "ASC" : "DESC")
    }else if (event.multiSortMeta !== undefined && event.multiSortMeta != null) {
      event.multiSortMeta.forEach(value => {
        obj = {...obj, ...this.createNestedObject(value.field, value.order == 1 ? "ASC" : "DESC" )}
      })
    }
    return obj
  }

}
